import React from 'react';
import PdfLibrary from '../../components/PdfLibrary/PdfLibrary';

export default function BibliothequePage() {
  return (
    <div className="space-y-6 animate-fade-in px-4">
      <div className="text-center space-y-2 max-w-3xl mx-auto">
        <h1 className="font-title text-3xl sm:text-4xl font-extrabold text-acem-primary-dark">
          Bibliothèque Numérique ACEM Fès
        </h1>
        <p className="text-sm sm:text-base text-acem-muted">
          Consultez et téléchargez gratuitement nos ressources pédagogiques, annales d'examens, cours et livres d'étude.
        </p>
      </div>

      <PdfLibrary />
    </div>
  );
}
